export const i18n = {
  defaultLocale: "en",
  locales: ["en", "de", "es", "nl"],
  localeLabels: {
    en: "English",
    de: "Deutsch",
    es: "Español",
    nl: "Nederlands",
  },
} as const;

export type Locale = (typeof i18n)["locales"][number];
